import type { UseQueryResult } from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { COMMENT_API_PREFIX } from 'shared/api/constants/api-constants'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import type { UseQueryClearOptions } from 'shared/types/tanstack-utility-types'
import { commentsKeys } from './key-factory'
import type { LikeInterface } from './types'

export const useCommentLikes = ({
  commentId,
  enabled = true,
  options,
}: {
  commentId?: number
  enabled?: boolean
  options?: Omit<UseQueryClearOptions<LikeInterface[], Error, LikeInterface[]>, 'enabled'>
}): UseQueryResult<LikeInterface[], Error> => {
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.get, LikeInterface[]>({
    method: RequestMethodsEnum.get,
  })

  return useQuery(
    queryOptions({
      ...options,
      queryKey: commentsKeys.likes(commentId ?? 0),
      queryFn: () => fetcher(`${COMMENT_API_PREFIX}/${commentId}/last_likes`),
      enabled: enabled && Boolean(commentId),
    }),
  )
}
